import React from "react";
import { useClientProfileToggle } from "./useClientProfileToggle";
import { getClientProfileRenderer } from "./registry";
import { OrderWithClientProfile, RendererOrder } from "./types";
import { RendererSlot } from "./registry.types";

type ClientProfileSectionProps = {
  order: RendererOrder;
  slot: RendererSlot;
  fallback?: React.ReactNode;
};

export const ClientProfileSection: React.FC<ClientProfileSectionProps> = ({
  order,
  slot,
  fallback = null,
}) => {
  const { enabled } = useClientProfileToggle();

  if (!enabled || !order.clientProfile) {
    return <>{fallback}</>;
  }

  const renderer = getClientProfileRenderer(order.clientProfile.ownerType);
  const Component = renderer[slot];
  return <Component order={order as OrderWithClientProfile} />;
};
